import React, { useEffect } from 'react';
import {
    Create,
    ReferenceInput,
    SelectInput,
    SimpleForm,
    TextInput,
    FormDataConsumer,
    useDataProvider,
} from 'react-admin';
import { useForm, useFormState } from 'react-final-form';

import { BoxStatus } from '../constants';
import useIsAdmin from '../hooks/useIsAdmin';

const CustomerPrefillPartnerCountry = () => {
    const form = useForm();
    const { values } = useFormState();
    const dataProvider = useDataProvider();
    const isAdmin = useIsAdmin();

    useEffect(() => {
        if (!values.userId) return;

        dataProvider
            .getOne('users', { id: values.userId })
            .then(({ data: user }) => {
                if (user?.partnerId) form.change('partnerId', user.partnerId);
                if (user?.countryId) form.change('countryId', user.countryId);
            })
            .catch(err => console.error('Error fetching user:', err));
    }, [values.userId]);

    return null;
};

const BoxCreate = props => {
    const isAdmin = useIsAdmin(props?.permissions);

    return (
        <Create {...props}>
            <SimpleForm variant="outlined">
                <CustomerPrefillPartnerCountry />

                <TextInput source="code" />

                <ReferenceInput
                    label="Customer"
                    source="userId"
                    reference="users"
                    resource="users"
                >
                    <SelectInput optionText="name" />
                </ReferenceInput>

                <FormDataConsumer>
                    {({ formData }) => (
                        <ReferenceInput
                            label="Partner"
                            source="partnerId"
                            reference="partners"
                            resource="partners"
                        >
                            <SelectInput
                                optionText="name"
                                disabled={!isAdmin && !!formData.userId}
                            />
                        </ReferenceInput>
                    )}
                </FormDataConsumer>

                <FormDataConsumer>
                    {({ formData }) => (
                        <ReferenceInput
                            label="Country"
                            source="countryId"
                            reference="country"
                            resource="country"
                        >
                            <SelectInput
                                optionText="name"
                                disabled={!isAdmin && !!formData.userId}
                            />
                        </ReferenceInput>
                    )}
                </FormDataConsumer>

                <SelectInput
                    source="status"
                    choices={Object.values(BoxStatus).map(i => ({
                        id: i,
                        name: i,
                    }))}
                />
            </SimpleForm>
        </Create>
    );
};

export default BoxCreate;
